import { Input, NumericInput } from "Components/Form/Input";

import { PaddedSurface } from "App/global-style";
import { InputMode } from "Components/Form/Input/inputTypes";
import { TextManager } from "Components/TextContext";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductIntroFormValues } from "./boatProductIntroInterfaces";

interface Props {
  formProps: FormikProps<Partial<BoatProductIntroFormValues>>;
}

export const MotorBoatOutboardsFormElements = ({
  formProps,
}: Props): React.ReactElement => {
  const { getText } = TextManager;

  return (
    <PaddedSurface>
      <Input
        id="engineBrand"
        name="engineBrand"
        label={getText("boatform.label.enginebrand")}
        hint={getText("boatform.hint.enginebrand")}
        error={getError("engineBrand", formProps)}
        large
        inputProps={{ maxLength: 20 }}
        inputMode={InputMode.TEXT}
      />
      <NumericInput
        id="engineHorsePower"
        name="engineHorsePower"
        label={getText("boatform.label.enginehorsepower")}
        error={getError("engineHorsePower", formProps)}
        inputMode={InputMode.NUMERIC}
        inputProps={{ maxLength: 5 }}
      />
      <NumericInput
        id="engineTopSpeed"
        name="engineTopSpeed"
        label={getText("boatform.label.enginetopspeed")}
        error={getError("engineTopSpeed", formProps)}
        inputMode={InputMode.NUMERIC}
        inputProps={{ maxLength: 5 }}
        large
      />
    </PaddedSurface>
  );
};
